<dx-number-box #input [(value)]="value" [showSpinButtons]="true" [showClearButton]="true" stylingMode="underlined"></dx-number-box>
